import { Box, Text } from "@chakra-ui/react";
import { useLanguage } from "../LanguageContext";

const Footer = () => {
  const {language} = useLanguage()
  const isEnglish = language === "en";

  return (
    <Box
      as="footer"
      bg="gray.800"
      color="white"
      textAlign="center"
      mt="auto" // This ensures the footer sticks to the bottom of the page
      position="relative" // Fix the position of the footer
      bottom="0" // Place the footer at the bottom of the viewport
      width="100%" // Ensure the footer spans the full width of the viewport
      padding={10}
    >
      <Text
        fontSize={{base:"large"}}
      >{isEnglish ? "© 2025 Balgod. All rights reserved." : "© 2025 Balgod. Todos los derechos reservados."}</Text>
      <Text
        fontSize={{base:"sm"}}
      > {isEnglish ? (
        <>
          Developed by{" "}
          <a href="https://bravotech.me" target="_blank" rel="noopener noreferrer">
            Bravo Technologies
          </a>.
        </>
      ) : (
        <>
          Desarrollado por{" "}
          <a href="https://bravotech.me" target="_blank" rel="noopener noreferrer">
            Bravo Technologies
          </a>.
        </>
      )} 
      
      </Text>
    </Box>
  );
};

export default Footer;